import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

import {Form, ErrorContainer} from 'form';

import ModalConfimEmail from './ModalConfimEmail';

import '../../sass/modals/modalChangeEmail.scss';

import {changeEmail} from 'backend-helpers/member';
import {shouldShowPrompt, markPromptShown} from 'utils/emailUndeliverable';

// Asks a member whose address cannot receive email (backend flag `email_undeliverable`)
// for a new one. Shown at most once per session and can be closed. The new address is
// sent to POST member/change/email; the backend emails a confirmation link and the flag
// stays 1 until that link is followed, so after success we show "check your mailbox"
// instead of the form.
export default function ModalEmailUndeliverable({currentUser}) {
    const [visible, setVisible] = useState(false);
    const [newEmail, setNewEmail] = useState(null);

    // Client side only (effects do not run during SSR).
    useEffect(() => {
        const storage = typeof window !== 'undefined' ? window.sessionStorage : undefined;

        if (shouldShowPrompt(currentUser, storage)) {
            markPromptShown(storage);
            setVisible(true);
        }
    }, [currentUser && currentUser.email_undeliverable, currentUser && currentUser.uid]);

    if (!visible) return null;

    const close = () => setVisible(false);

    if (newEmail) {
        return <ModalConfimEmail newEmail={newEmail} closeFn={close}/>;
    }

    const onSubmit = (formData, setErrors) => {
        if (formData.email !== formData.email_confirmation) {
            setErrors(t('Email address and confirmation do not match.'));
            return;
        }

        changeEmail(formData).then(() => {
            setNewEmail(formData.email);
        }).catch(error => {
            // Backend messages are already localized (e.g. email_address_undeliverable
            // when the new address is itself known as dead). Pass the joined string
            // (error.message), not the raw array (error.messages): Form.setErrors treats
            // an object/array as per-field errors and would render nothing.
            setErrors(error.message);
        });
    };

    return (
        <Modal className="change-email" show={true} onHide={close}>
            <Modal.Body>
                <div className="close" onClick={close}></div>
                <p className="modal-title">{t('Change email')}</p>
                <div className="form">
                    <Form onSubmit={onSubmit}>
                        <ErrorContainer data-errorcontainer={true}/>
                        <div className="form-group">
                            <label>{t('We cannot reach you at %1. Please enter a new email address so you can recover your password and receive notifications.', currentUser.email)}</label>
                        </div>
                        <div className="form-group">
                            <label>{t('New email address:')}</label>
                            <input type="email" name="email"/>
                        </div>
                        <div className="form-group">
                            <label>{t('New email address again:')}</label>
                            <input type="email" name="email_confirmation"/>
                        </div>
                        <div className="form-group-buttons">
                            <button type="submit" className="save-name">{t('Save')}</button>
                            <button type="button" className="close-name" onClick={close}>{t('Cancel')}</button>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/modals/ModalEmailUndeliverable.js